import { render, staticRenderFns } from "./FullNewsPage.vue?vue&type=template&id=e552be6c&scoped=true"
import script from "./FullNewsPage.vue?vue&type=script&lang=js"
export * from "./FullNewsPage.vue?vue&type=script&lang=js"
import style0 from "./FullNewsPage.vue?vue&type=style&index=0&id=e552be6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e552be6c",
  null
  
)

export default component.exports